<template>
  <v-dialog v-model="isShow" persistent width="80%" min-width="200" max-width="500">
    <div class="popup-box">

      <div id="printArea" ref="qrCodeContainer">
        <div>
          <span class="popup-title mb-4">
            {{ t('view_QR') }}
          </span>
          <span class="popup-contents mb-10">
            {{ t('view_QR_tip') }}
          </span>
          <div class="qr-code-row mb-10">
            <div class="qr-code">
              <qrcode-vue :value="qrValue" :size="380" :level="'H'" />
            </div>
          </div>
        </div>
      </div>

      <div class="popup-btn">
        <cBtn :thema="'dark-yellow'" :btnText="t('print')" :btnSize="16"
          :customDesign="{ width: 'calc(50% - 4px)', marginRight: '8px', fontWeight: 'bold' }"
          @onClicked="handleClick('print')"></cBtn>
        <cBtn :thema="'gray'" :btnText="t('cancel')" :btnSize="16" :customDesign="{ width: 'calc(50% - 4px)' }"
          @onClicked="handleClick('cancel')"></cBtn>
      </div>
    </div>
  </v-dialog>
</template>

<script setup>
import { onMounted, defineProps, defineEmits, computed, ref } from 'vue';
import { useBaseStore } from '@/stores/base'
import CBtn from '@/components/cBtn.vue'
import { useI18n } from "vue-i18n";
import html2canvas from 'html2canvas'
import QrcodeVue from 'qrcode.vue';

const baseStore = useBaseStore()
const { t, locale } = useI18n();
const qrCodeContainer = ref(null)

const props = defineProps({
  isShow: {
    type: Boolean,
    default: false
  },
});
const isShow = computed(() => {
  return props.isShow
})

onMounted(() => {

})
const qrValue = computed(() => {
  return baseStore.qrInfo
})

const emit = defineEmits([
  'onClicked'
])

const qrCutby4 = (str) => {
  let result = "";
  for (let i = 0; i < str.length; i += 4) {
    result = result +  `<span>${str.slice(i, i + 4)}</span>` 
  }
  return result;
}
const handleClick = async (action) => {
  if (action === 'print') {

    const qrCodeElement = qrCodeContainer.value  // QR 코드 DOM 요소 참조
    const canvas = await html2canvas(qrCodeElement)  // html2canvas로 요소 캔버스로 변환
    const image = canvas.toDataURL('image/png')
    const qrCode = qrValue.value

    const qrCutby4Val = qrCutby4(qrCode)
    console.log(qrCutby4Val)



    // 새 창의 크기
    const windowWidth = 800;
    const windowHeight = 600;

    // 스크린의 중앙 위치 계산
    const left = (screen.width / 2) - (windowWidth / 2);
    const top = (screen.height / 2) - (windowHeight / 2);

    // 새 창을 스크린 중앙에 열기
    const printWindow = window.open('', '', `height=${windowHeight},width=${windowWidth},left=${left},top=${top}`);
    printWindow.document.write(`
        <html>
            <head>
                <title>Print</title>
                <style>
                    body {
                        margin: 0; /* 기본 여백 제거 */
                        height: 100vh; /* 뷰포트 높이 100% */
                        overflow: hidden; /* 스크롤바 제거 */
                    }
                    img {
                        width: 100%; /* 이미지 폭을 100%로 설정 */
                        height: auto; /* 높이는 자동으로 조정 */
                        display: block; /* 블록 요소로 설정하여 여백 제거 */
                    }
                    .qrcode {
                      display: grid;
                      padding: 40px 120px 0px;
                      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;

                      span {
                        font-size: 24px;
                        letter-spacing: -1.2px;
                        font-weight: 600;
                        font-family: 'Pretendard';
                        color: #111;
                      }
                    }
                </style>
            </head>
            <body>
                <img src="${image}" />
                <div class="qrcode">${qrCutby4Val}</div>
            </body>
        </html>
    `);
    printWindow.document.close()
    // 인쇄 후 새 창 닫기
    printWindow.onload = function () {
      printWindow.print();
      printWindow.onafterprint = function () {
        printWindow.close()
      }
    }
    emit('onClicked')
  } else {
    // console.log("여기온다. ")
    emit('onClicked')
  }
}

</script>
<style lang="scss" scoped>
@import '@/sass/app.scss';

.popup-box {
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  background-color: #fff;
  width: 100%;
  padding: 32px 24px 24px;
  box-sizing: border-box;
}

.popup-title {
  display: inline-block;
  width: 100%;
  font-size: 24px;
  letter-spacing: -1.2px;
  line-height: 24px;
  font-weight: 600;
  font-family: 'Pretendard';
  color: #111;

}

.popup-contents {
  display: inline-block;
  width: 100%;
  font-size: 15px;
  letter-spacing: -0.4px;
  line-height: 24px;
  font-family: 'Pretendard';
  color: #666;
}

.printArea {
  width: 100%;
  height: 100%;
}

.qr-code-row {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-code {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 440px;
  height: 440px;
  background-image: url('@/assets/qr-bg.png');
  background-position: center;
  background-size: cover;
  margin: 0px auto;
}

.qr-code-body {
  width: 286px;
  height: 286px;
}

.popup-btn {
  width: 100%;
  display: flex;
  justify-content: end;
}
</style>
